import React from 'react';
import './ProductCardAdmin.css';
import placeholderImage from '../../../assets/admin/images/placeholder.svg';
import SuccessButton from '../../shared/SuccessButton';
import ErrorButton from '../../shared/ErrorButton';

const S3_BUCKET_NAME = "resto-online";
const S3_BUCKET_REGION = "eu-north-1";
const S3_BASE_URL = `https://${S3_BUCKET_NAME}.s3.${S3_BUCKET_REGION}.amazonaws.com/`;

const ProductCard = ({ product, onEditClick, onDeleteClick }) => {
  // Format price to Belgian Euro format
  const formatPrice = (price) => {
    const numPrice = typeof price === 'object' && price.$numberDecimal 
      ? parseFloat(price.$numberDecimal) 
      : parseFloat(price);
    
    return new Intl.NumberFormat('nl-BE', {
      style: 'currency',
      currency: 'EUR'
    }).format(numPrice);
  };

  return (
    <div className="product-card">
      <div className="product-image-container">
        <img 
          src={product.hasImage ? `${S3_BASE_URL}${product._id}?t=${Date.now()}` : placeholderImage} 
          alt={product.name} 
          className="product-image"
        />
        {product.soldAlone === false && <div className="product-tag">Menu item</div>}
      </div>
      
      <div className="product-content">
        <h3 className="product-title">{product.name}</h3>
        <p className="product-description">{product.description || "Geen beschrijving"}</p>
        
        <div className="product-details">
          <div className="product-price">{formatPrice(product.price)}</div>
          
          {product.collection && (
            <div className="product-collection">
              <span className="collection-icon"><img src={product.collection.icon} alt={product.collection.name} /></span>
              <span className="collection-name">{product.collection.name}</span>
            </div>
          )}
          
          {product.stockQuantity !== null && product.stockQuantity !== undefined && (
            <div className="product-stock">
              <span className="stock-label">Voorraad:</span>
              <span className="stock-quantity">{product.stockQuantity}</span>
            </div>
          )}
        </div>
      </div>
      
      <div className="product-actions">
        <SuccessButton onClick={onEditClick} className="edit-button">
        <i class="fi fi-rs-pencil"></i>
          <span>Bewerken</span>
        </SuccessButton>
        
        <ErrorButton onClick={onDeleteClick} className="delete-button">
        <i class="fi fi-rs-trash-xmark"></i>
          <span>Verwijderen</span>
        </ErrorButton>
      </div>
    </div>
  );
};

export default ProductCard; 